module.exports = __webpack_public_path__ + "static/media/icon-kitchen-trash.4cf04f6b.svg";